<template>
  <div style="padding: 15px" class="bg-white" v-loading="isLoading">
    <h4 class="form-title">Repair - Job Order Information</h4>
    <el-form
      ref="form"
      :model="formModel"
      :rules="rules"
      label-position="top"
      :readonly="isFormDisabled()"
    >
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="Job Order No.">
            <el-input
              v-model="formModel.job_order_number"
              :readonly="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="Date Received" prop="date_received">
            <el-input
              v-if="isRole([1, 4])"
              :readonly="true"
              :disabled="true"
              v-model="formModel.date_received"
            ></el-input>
            <el-date-picker
              v-else
              type="date"
              :disabled="isFormDisabled()"
              v-model="formModel.date_received"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="Repair Station" prop="station_id">
            <el-select
              v-model="formModel.station_id"
              filterable
              clearable
              :readonly="isRole([2, 3])"
              :disabled="isRole([2, 3])"
            >
              <el-option
                v-for="loc in locations"
                :key="loc.id"
                :value="loc.id"
                :label="loc.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :sm="12">
          <el-form-item label="Location" prop="location_id">
            <el-select v-model="formModel.location_id" filterable clearable>
              <el-option
                v-for="loc in locations"
                :key="loc.id"
                :value="loc.id"
                :label="loc.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
        <el-col :sm="12">
          <el-form-item label="Collected From" prop="collected_from">
            <el-input :disabled="isFormDisabled()" v-model="formModel.collected_from"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="ULD ID Code" prop="masterlist_id">
            <div class="d-flex">
              <div style="flex: 1 0 0">
                <!-- <el-select
                  v-model="formModel.masterlist_id"
                  clearable
                  filterable
                  remote
                  :remote-method="findMasterlist"
                  :readonly="isRole([2, 3])"
                  :disabled="isRole([2, 3])"
                > -->
                <el-select
                  v-model="formModel.masterlist_id"
                  clearable
                  filterable
                  remote
                  :disabled="isFormDisabled()"
                  :remote-method="findMasterlist"
                >
                  <el-option
                    v-for="item in masterlist"
                    :key="item.id"
                    :label="item.uld_id_code"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div style="margin-left: 15px;" v-if="formModel.masterlist_id">
                <el-button
                  style="height: calc(100% - 2px)"
                  title="View CMM Details"
                  type="primary"
                  icon="el-icon-position"
                  size="small"
                  @click="viewMasterlistInfo"
                ></el-button>
              </div>
            </div>

          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="Pre-Inspection Date" prop="pre_inspection_date">
            <!-- <el-input
              v-if="isRole([1, 4])"
              :readonly="true"
              :disabled="true"
              v-model="formModel.pre_inspection_date"
            ></el-input> -->
            <el-date-picker
              type="date"
              :disabled="isFormDisabled()"
              :picker-options="{
                  disabledDate: disabledPreInsDate
              }"
              v-model="formModel.pre_inspection_date"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="Pre-Inspected by" prop="pre_approved_by_id">
            <!-- <el-input v-model="formModel.supervisor_id"></el-input> -->
            <el-select
              v-model="formModel.pre_approved_by_id"
              :readonly="isRole([2, 3])"
              :disabled="isRole([2, 3])"
              filterable
            >
              <el-option
                v-for="m in supervisors"
                :key="m.id"
                :value="m.id"
                :label="m.first_name + ' ' + m.last_name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="formModel.id">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="Job Completed" prop="job_completed">
              <el-input
                v-if="isRole([2, 3])"
                :disabled="true"
                :readonly="true"
                v-model="formModel.job_completed"
              ></el-input>
              <el-date-picker
                v-else
                type="date"
                v-model="formModel.job_completed"
                :picker-options="{
                  disabledDate: disabledDates
                }"
                @change="checkJobCompleted"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="Status" prop="status_id">
              <el-select
                v-model="formModel.status_id"
                :readonly="isRole(2)"
                :disabled="isRole([2,3])"
                filterable
              >
                <el-option
                  v-for="s in repairStatus"
                  :value="s.id"
                  :key="s.id"
                  :label="s.name"
                  :disabled="checkRole(s)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="Mechanic" prop="mechanic_id">
              <!-- <el-input v-model="formModel.mechanic_id"></el-input> -->
              <el-select
                v-model="formModel.mechanic_id"
                :readonly="isRole([2, 3])"
                :disabled="isRole([2, 3])"
                filterable
              >
                <el-option
                  v-for="m in mechanics"
                  :key="m.id"
                  :value="m.id"
                  :label="m.first_name + ' ' + m.last_name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="Final Inspected by:" prop="supervisor_id">
              <!-- <el-input v-model="formModel.supervisor_id"></el-input> -->
              <el-select
                v-model="formModel.supervisor_id"
                :readonly="isRole([2, 3])"
                :disabled="isRole([2, 3])"
                filterable
              >
                <el-option
                  v-for="m in supervisors"
                  :key="m.id"
                  :value="m.id"
                  :label="m.first_name + ' ' + m.last_name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="Customer/Airline" prop="customer">
              <el-select
                v-model="formModel.customer"
                clearable
                filterable
                :readonly="isRole([2, 3])"
                :disabled="isRole([2, 3])"
              >
                <el-option
                  v-for="d in customers"
                  :value="d.value"
                  :key="d.value"
                  :label="d.text"
                ></el-option>
              </el-select>
              <!-- <el-input v-model="formModel.customer"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="Cleaning Cost" prop="cleaning_cost">
              <el-input-number
                v-model.number="formModel.cleaning_cost"
                :controls="false"
                :precision="2"
                :disabled="isFormDisabled()"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="Rate" prop="rate">
              <el-input-number
                v-model.number="formModel.rate"
                :controls="false"
                :precision="2"
                :disabled="isFormDisabled()"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col v-if="status.code == 'EST'" :sm="12">
            <el-form-item label="BER" prop="ber">
              <el-input-number
                v-model.number="formModel.ber"
                :controls="false"
                :precision="2"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="Remarks" prop="remarks">
              <el-input type="textarea" v-model="formModel.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="status.code == 'REP' || status.code == 'EST'" :gutter="0">
          <el-form-item label="Total Repair Time" prop="time_rendered_hours">
            <el-col :md="3" :sm="11">
              <span>Hours</span>
              <el-input-number
                v-model="formModel.time_rendered_hours"
                controls-position="right"
                :precision="0"
                :step="1"
                :min="0"
                step-strictly
              ></el-input-number>
            </el-col>
            <el-col class="ml-2" :md="3" :sm="11">
              <span>Minutes</span>
              <el-input-number
                v-model="formModel.time_rendered_minutes"
                controls-position="right"
                :precision="0"
                :step="15"
                :min="0"
                :max="45"
                step-strictly
              ></el-input-number>
            </el-col>
          </el-form-item>
        </el-row>
      </template>
    </el-form>
    <MasterlistForm ref="masterlistForm" />

    <!-- Damage Table -->
    <div v-if="formModel.id" class="mt-3">
      <h4 class="form-title">Damages</h4>
      <el-table :data="damages" key="damage_table">
        <el-table-column label="Actions" width="140">
          <template slot-scope="scope">
            <el-button
              v-if="!isLocked && isRole([1, 3, 4])"
              type="primary"
              icon="el-icon-edit"
              title="Edit information"
              circle
              size="small"
              @click="editDamage(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              title="Delete information"
              circle
              size="small"
              @click="daleteDamage(scope.row)"
              v-if="!isLocked && isRole([1, 4])"
            ></el-button>
            <el-button
              type="success"
              icon="el-icon-s-check"
              title="View Spare Parts"
              circle
              size="small"
              @click="viewAttachedParts(scope.row)"
              v-if="isRole([1, 3, 4])"
            ></el-button>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          label="Damage Part / Panel"
          prop="damage_part"
        >
          <!-- <template slot-scope="scope">
            {{ getPart(scope.row.damage_part_id) }}
          </template> -->
        </el-table-column>
        <el-table-column min-width="120px" label="Damage" prop="damage">
          <template slot-scope="scope">
            {{ getDamageDescription(scope.row.damage) }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          label="Action Required"
          prop="action_required"
        >
          <template slot-scope="scope">
            {{ getActionDescription(scope.row.action_required) }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          label="Repaired By"
          prop="repaired_by"
        >
          <template slot-scope="scope">{{ scope.row.repaired_by }}</template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Spare Part Table -->
    <div class="mt-5" v-if="spareParts.data && !isLocked">
      <h4 class="form-title">Requested Parts</h4>
      <el-table :data="spareParts.data" key="requested_parts_table">
        <el-table-column label="Actions" width="140">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              title="Edit information"
              circle
              size="small"
              @click="$refs.requestSpareParts.open(scope.row)"
              v-if="scope.row.status == 'Pending'"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              title="Delete information"
              circle
              size="small"
              @click="deleteRequest(scope.row)"
              v-if="scope.row.status == 'Pending'"
            ></el-button>
            <el-button
              type="success"
              icon="el-icon-check"
              title="Approve Request"
              circle
              size="small"
              v-if="scope.row.status == 'Pending' && isRole([1, 4])"
              @click="updateStatus(scope.row, 1)"
            ></el-button>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          label="Status"
          prop="status"
        ></el-table-column>
        <el-table-column min-width="100" label="Part No" prop="part_no">
          <template slot-scope="scope">
            <a
              target="_blank"
              :href="'/parts/info/' + scope.row.requested_parts.id"
              >{{ scope.row.requested_parts.part_no }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          min-width="150"
          label="Part Description"
          prop="requested_parts.description"
        ></el-table-column>
        <el-table-column
          min-width="150"
          label="Remarks"
          prop="description"
        ></el-table-column>
        <el-table-column
          min-width="100"
          label="Quantity"
          prop="quantity"
        ></el-table-column>
      </el-table>
      <div v-if="isRole([1, 2])">
        <el-button class="mt-1" type="success" size="small" @click="openScan()"
          >Scan part for approval</el-button
        >
        <app-dialog
          ref="approvalDialog"
          v-loading="scan.loading"
          :preventClose="scan.loading"
        >
          <div>
            <label>Scan part for approval</label>
            <el-input
              v-model="scan.part"
              @keydown.native.enter="processScan"
              placeholder="scan part and press enter to approve"
            ></el-input>
            <el-alert
              class="mt-1"
              type="error"
              :closable="false"
              v-if="scan.error"
              >{{ scan.error }}</el-alert
            >
          </div>
          <template v-slot:footer>
            <el-button type="primary" @click="processScan">Submit</el-button>
          </template>
        </app-dialog>
      </div>
    </div>

    <!-- form controls -->
    <el-row class="mt-2" v-if="isRole([1, 3])">
      <el-col>
        <el-checkbox v-model="notify">Notify Supervisor</el-checkbox>
      </el-col>
    </el-row>
    <div class="mt-2">
      <el-button
        v-if="!isLocked || isRole(1)"
        size="small"
        type="primary"
        @click="save"
        :disabled="isLoading"
        >Save</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="print"
        :disabled="isLoading"
        v-if="formModel.id"
        >Print</el-button
      >
      <template v-if="formModel.id && !isLocked">
        <template v-if="isRole([1, 3, 4])">
          <el-button
            size="small"
            type="primary"
            :disabled="isLoading"
            v-if="formModel.id"
            @click="$refs.damageForm.open()"
            >Add Damage</el-button
          >
        </template>
        <template v-if="isRole([1, 3])">
          <el-button
            size="small"
            type="warning"
            :disabled="isLoading"
            v-if="formModel.id"
            @click="requestParts"
            >Request Spare Parts</el-button
          >
        </template>
      </template>
      <template v-if="status.code == 'REP'">
        <el-button
          v-if="user.isRole([1, 3, 4])"
          size="small"
          @click="printForm('1A')"
          type="primary"
          >Print Form 1
          
          </el-button>
      </template>
      <template v-if="status.code == 'EST'">
        <el-button
          type="primary"
          size="small"
          @click="$refs.partEstimate.open()"
          v-if="isRole([1, 4])"
        >
          Estimate Info
        </el-button>
        <!-- @click="
            $router.push({
              name: 'repairEstimateReport',
              params: { id: formModel.id },
            })
          " -->
        <el-button
          v-if="isRole([1, 4])"
          type="primary"
          size="small"
          @click="printEstimate"
        >
          Estimate Report
        </el-button>
      </template>
      <el-button
        v-if="isRole([1])"
        type="warning"
        size="small"
        :disabled="isLoading"
        @click="changeLock()"
        >{{ formModel.locked ? "Unlock" : "Lock" }}</el-button
      >
      <el-button
        size="small"
        :disabled="isLoading"
        @click="$router.push({ name: 'repairULD' })"
        >Cancel</el-button
      >
    </div>
    <DamageForm ref="damageForm" />
    <DamageSpareParts
      ref="damageSpareParts"
      :readonly="isLocked"
      :locked="formModel.locked"
    />
    <RequestSpareParts ref="requestSpareParts" />
    <spare-parts ref="spareParts"></spare-parts>
    <part-estimate ref="partEstimate"></part-estimate>
  </div>
</template>

<script>
import moment from "moment";
import socket from "@/socket";

import Masterlist from "@/models/Masterlist";
import Part from "@/models/Part";
import RepairDamage from "@/models/RepairDamage";
import RepairLocation from "@/models/RepairLocation";
import RepairStatus from "@/models/RepairStatus";
import ULD from "@/models/ULD";
import User from "@/models/User";

import MasterlistForm from "../Masterlist/masterlistForm.vue";
import DamageForm from "./damages.vue";
import DamageSpareParts from "./damageSpareParts.vue";
import RequestSpareParts from "./requestSpareParts.vue";
import SpareParts from "./multipleSpareParts.vue";
import PartEstimate from "./estimate.vue";

export default {
  name: "info",
  components: {
    MasterlistForm,
    DamageForm,
    DamageSpareParts,
    RequestSpareParts,
    SpareParts,
    PartEstimate
  },
  data() {
    return {
      isLoading: false,
      formModel: new ULD(),
      rules: {
        masterlist_id: [{ required: true, message: "Masterlist is required." }],
        date_received: [
          { required: true, message: "Date received is required." }
        ],
        customer: [{ required: true, message: "Customer is required." }],
        location_id: [{ required: true, message: "Location is required." }],
        station_id: [
          { required: true, message: "Repair Station is required." }
        ],
        job_completed: [
          {
            validator: (rule, value, callback) => {
              let status = this.repairStatus.find(
                o => o.id == this.formModel.status_id
              );
              if (status && status.code == "REP" && !value) {
                return callback(new Error("Job Completed is required."));
              }
              if (
                moment(value).isBefore(moment(this.formModel.date_received))
              ) {
                return callback(
                  new Error("Job Completed should be after the Date Received")
                );
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        mechanic_id: [
          {
            validator: (rule, value, callback) => {
              let status = this.repairStatus.find(
                o => o.id == this.formModel.status_id
              );
              if (status && status.code == "REP" && !value) {
                return callback(new Error("Mechanic is required."));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        supervisor_id: [
          {
            validator: (rule, value, callback) => {
              let status = this.repairStatus.find(
                o => o.id == this.formModel.status_id
              );
              if (status && status.code == "REP" && !value) {
                return callback(new Error("Supervisor is required."));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        time_rendered_hours: [
          {
            required: true,
            type: "number",
            min: 0,
            message: "Total Repair Time is required.",
            triiger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (this.status.code != "REP") callback();
              if (
                this.formModel.time_rendered_hours ||
                this.formModel.time_rendered_minutes
              )
                callback();
              callback("Total Repair Time is required.");
            },
            trigger: "blur"
          }
        ],
        collected_from: [
          { required: true, message: "Collected From is required." }
        ]
      },
      // damages: [],
      codes: [],
      locations: [],
      masterlist: [],
      repairStatus: [],
      supervisors: [],
      mechanics: [],
      damageParts: [],
      customers: [],
      // damageList: ULD.damage_descriptions(),
      actionList: ULD.action_taken(),
      notify: false,
      scan: {
        part: "",
        error: null,
        loading: false
      }
      // categories: ULD.categories(),
    };
  },
  computed: {
    isLocked() {
      if (this.user && this.user.user_type == 1) return false;

      return this.formModel.locked ? true : false;
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    damages() {
      return this.$store.getters["uld/info"].damages;
    },
    spareParts() {
      return this.$store.getters["uld/spareParts"];
    },
    status() {
      let stat = this.repairStatus.find(o => o.id == this.formModel.status_id);
      if (stat) return stat;
      return {};
    },
    damageList() {
      return this.$store.getters["uld/damageDescriptions"];
    }
  },
  methods: {
    getLibrary() {
      RepairLocation.list({ limit: 99999 }).then(list => {
        this.locations = list.data;
      });
      // Masterlist.list({ limit: 99999 }).then(list => {
      //   this.masterlist = list.data;
      // });
      Masterlist.searchUld({
        q: "",
        limit: 15
      }).then(resp => {
        this.masterlist = resp;
      });
      User.list({ user_type: "mechanic", limit: 99999 }).then(list => {
        this.mechanics = list.data;
      });
      User.list({ user_type: "supervisor", limit: 99999 }).then(list => {
        this.supervisors = list.data;
      });
      RepairStatus.list({ limit: 99999 }).then(list => {
        this.repairStatus = list.data;
      });
      RepairDamage.list({ limit: 99999 }).then(list => {
        this.damageParts = list.data;
      });
      this.customers = [];
      ULD.customers_data().then(list => {
        this.customers = list;
      });
    },
    checkRole(status) {
      let mechanic_id = this.formModel.mechanic_id
        ? this.formModel.mechanic_id
        : null;
      let supervisor_id = this.formModel.supervisor_id
        ? this.formModel.supervisor_id
        : null;
      let pre_approved_by_id = this.formModel.pre_approved_by_id
        ? this.formModel.pre_approved_by_id
        : null;
      if (this.user.user_type == 3 && ["ON", "FI"].includes(status.code)) {
        return true;
      }

      if (["REP"].includes(status.code)) {
        if (supervisor_id === null) return true;
        if (pre_approved_by_id === null) return true;
        if (mechanic_id === null) return true;
      }

      return false;
    },
    isRole(param) {
      let res = false;
      if (Array.isArray(param) && param.find(o => o == this.user.user_type)) {
        res = true;
      } else {
        if (this.user.user_type == param) {
          res = true;
        }
      }
      return res;
    },
    isRoleReadonly(role) {
      let res = true;
      if (this.user.user_type == 1) res = false;
      else if (this.user.user_type == role) res = false;
      return res;
    },
    viewMasterlistInfo() {
      this.$refs.masterlistForm.open(this.formModel.masterlist_id);
    },
    print() {
      window.open(`/print/uld/${this.formModel.id}`);
    },
    printEstimate() {
      window.open(`/print/repair-estimate-report/${this.formModel.id}`);
    },
    getPart(value) {
      let obj = this.damageParts.find(o => o.id == value);
      if (obj) {
        return obj.name;
      }
      return "";
    },
    getDamageDescription(key) {
      let dd = this.damageList.find(o => o.id == key);
      if (dd) {
        return dd.name;
      }
      return "";
    },
    getActionDescription(key) {
      let dd = this.actionList.find(o => o.value == key);
      if (dd) {
        return dd.text;
      }
      return "";
    },
    changeLock() {
      this.$confirm(
        `Do you want to ${
          this.formModel.locked ? "unlock" : "lock"
        } this Job Order?`
      )
        .then(() => {
          let payload = {
            locked: !this.formModel.locked,
            id: this.formModel.id
          };

          this.isLoading = true;
          ULD.update(payload).then(() => {
            window.location.reload();
          });
        })
        .catch(() => {});
    },
    async save() {
      let confirmed = false;

      if (this.notify) {
        confirmed = await this.$confirm(
          "The supervisor will be notified once this Job Order is saved.",
          {
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        ).catch(() => {});
      } else {
        confirmed = true;
      }

      if (!confirmed) return;

      this.$confirm("Do you want to save the Job Order information?")
        .then(() => {
          this.$refs.form.validate(valid => {
            if (!valid) return false;

            this.formModel.date_received = moment(
              this.formModel.date_received
            ).format("YYYY-MM-DD");
          
            this.formModel.pre_inspection_date = moment(
              this.formModel.pre_inspection_date
            ).format("YYYY-MM-DD");

            if (this.formModel.job_completed) {
              this.formModel.job_completed = moment(
                this.formModel.job_completed
              ).format("YYYY-MM-DD");
            }
            this.formModel.locked = this.formModel.locked ? 1 : 0;

            let payload = { ...this.formModel };
            delete payload._default;
            delete payload.damages;
            delete payload.estimates;

            if (!this.formModel.mechanic_id) {
              delete payload.mechanic;
              delete payload.mechanic_id;
            }

            if (!this.formModel.supervisor_id) {
              delete payload.supervisor;
              delete payload.supervisor_id;
            }

            if (!this.formModel.pre_approved_by_id) {
              delete payload.pre_approved_by_id;
              delete payload.pre_approved_by_id;
            }

            let status = this.repairStatus.find(o => o.id == payload.status_id);

            if (status && (status.code == "REP" || status.code == "FFI")) {
              if (this.damages.length == 0) {
                // validate if it has at least one (1) damage
                this.$notify({
                  type: "warning",
                  message:
                    "Create at least one (1) damage entry. Operation cancelled.",
                  position: "bottom-right"
                });
                return false;
              }

              // Allow job order to be "Repaired" even without parts used
              // let sparePartValidate = true;
              // for (let damage of this.damages) {
              //   if (damage.spare_parts.length == 0) sparePartValidate = false;
              // }
              // if (!sparePartValidate) {
              //   // validate if damage has at least one (1) part
              //   this.$notify({
              //     type: "warning",
              //     message:
              //       "Attach at least one (1) part to the damages. Operation cancelled.",
              //     position: "bottom-right"
              //   });
              //   return false;
              // }

              // lock ULD is all validation for REP passed
              if (status.code == "REP") payload.locked = true;
            }

            if (
              this.formModel.time_rendered_hours ||
              this.formModel.time_rendered_minutes
            ) {
              payload.time_rendered = `${this.formModel.time_rendered_hours}:${this.formModel.time_rendered_minutes}`;
            }

            if (this.notify) payload.notify_supervisor = 1;

            this.isLoading = true;
            ULD.update(payload).then(resp => {
              if (resp.code == 200) {
                this.$notify({
                  type: "success",
                  message: "Repair ULD information saved.",
                  position: "bottom-right"
                });

                if (resp.hasOwnProperty("notification")) {
                  // send notify
                  socket.emit("send_notification", {
                    sendto: "supervisor",
                    channel: `personal-channel.${resp.notification.user_id}`,
                    data: resp.notification
                  });
                }

                if (status && status.code == "REP") {
                  // send approved ULD request
                  ULD.supervisor_approved(payload.id).then(() => {
                    this.isLoading = false;
                    this.$router.push({ name: "repairULD" });
                  });
                } else {
                  this.isLoading = false;
                  this.$router.push({ name: "repairULD" });
                }
              }
            });
          });
        })
        .catch(() => {});
    },
    daleteDamage(damage) {
      this.$confirm("Do you want to delete this damage information?")
        .then(() => {
          // let obj = this.damages.find(o => o.id == damage.id);
          this.$store.dispatch("uld/deleteDamage", damage.id);
          let payload = {
            id: this.formModel.id,
            damages: this.damages
          };
          this.isLoading = true;
          ULD.update(payload).then(() => {
            this.isLoading = false;
            this.$store.dispatch("uld/fetch", this.formModel.id);
          });
        })
        .catch(() => {});
    },
    editDamage(damage) {
      this.$refs.damageForm.open(damage);
    },
    viewAttachedParts(damage) {
      this.$refs.damageSpareParts.open(damage);
    },
    submitUpdate(request, status, type) {
      let part = request.requested_parts;
      if (type == "auto") {
        this.scan.loading = true;
      } else {
        this.isLoading = true;
      }
      Part.getStocks(part.id).then(resp => {
        if ("total" in resp && resp.total >= request.quantity) {
          let payload = {
            ...request,
            job_order_no: request.uld_id,
            status: status,
            mechanic_id: this.formModel.mechanic_id,
            items: [
              {
                quantity: request.quantity,
                part_id: request.requested_parts.id,
                location: request.requested_parts.location,
                date_issued: moment().format("YYYY-MM-DD")
              }
            ]
          };
          ULD.update_requested_part(payload).then(resp => {
            this.isLoading = false;
            this.scan.loading = false;
            if (resp && resp.code == 200) {
              this.scan.part = null;
              this.$notify({
                message: `Request status updated.`,
                position: "bottom-right",
                type: "success"
              });
              // send notification
              socket.emit("send_notification", {
                sendto: "request_user",
                channel: `personal-channel.${resp.notification.user_id}`,
                data: resp.notification
              });
              // delete approved requests
              ULD.delete_requested_part(request.id).then(() => {
                // this.get_requested_parts();
                this.$store.dispatch("uld/fetchSpareParts", this.formModel.id);
              });
              // fetch stockout items
              this.$store.dispatch("uld/fetchStockoutItems", this.formModel.id);
            }
          });
        } else {
          this.isLoading = false;
          this.scan.loading = false;
          let stock = resp.total != null ? resp.total : 0;
          if (type == "auto") {
            this.scan.error = `This part only have ${stock} stocks.`;
          } else {
            this.$notify({
              message: `This part only have ${stock} stocks.`,
              position: "bottom-right",
              type: "error"
            });
          }
        }
      });
    },
    updateStatus(request, status) {
      this.$confirm("Do you want to approve this request?")
        .then(() => {
          this.submitUpdate(request, status);
        })
        .catch(() => {});
    },
    findMasterlist(queryString) {
      if (queryString.length >= 3) {
        Masterlist.searchUld({ q: queryString, limit: 15 }).then(resp => {
          this.masterlist = resp;
        });
      }
    },
    printForm(type) {
      let owner_code = this.masterlist[0].uld_id_code.slice(-2);
      if(owner_code == 'EK' || owner_code == 'EY') {
        window.open(`/print/uld-form-${type}/${this.formModel.id}`);
      } else {
        window.open(`/print/uld-form-easa/${this.formModel.id}`);
      }
    },
    requestParts() {
      if (this.damages.length > 0) this.$refs.spareParts.open();
      else
        this.$notify({
          message: "There should be at least one (1) damage created.",
          type: "warning",
          position: "bottom-left"
        });
    },
    deleteRequest(item) {
      this.$confirm("Do you want to delete this request?")
        .then(() => {
          this.isLoading = true;
          ULD.delete_requested_part(item.id).then(() => {
            this.$notify({
              message: "Spare part request deleted.",
              position: "bottom-right",
              type: "success"
            });
            this.$store.dispatch("uld/fetchSpareParts", this.formModel.id);
            this.isLoading = false;
          });
        })
        .catch(() => {});
    },
    disabledDates(date) {
      let now = moment();
      let received = moment(this.formModel.date_received);
      let _date = moment(date);
      if (
        _date.isBetween(received, now) ||
        received.format("MM/DD/YYYY") == _date.format("MM/DD/YYYY")
      ) {
        return false;
      } else {
        return true;
      }
    },
    disabledPreInsDate(date) {
      let now = moment();
      let received = moment(this.formModel.date_received);
      let _date = moment(date);
      if (
        _date.isAfter(received, now) ||
        received.format("MM/DD/YYYY") == _date.format("MM/DD/YYYY")
      ) {
        return false;
      } else {
        return true;
      }
    },
    openScan() {
      this.scan.part = "";
      this.scan.error = null;
      this.$refs.approvalDialog.open();
    },
    processScan() {
      this.scan.error = null;
      if (!this.scan.part) return;

      let part = this.spareParts.data.find(
        o => o.requested_parts.part_no == this.scan.part
      );
      if (!part) {
        this.scan.error = "Request with the part no given not found.";
        return;
      }

      this.submitUpdate(part, 1, "auto");
    },
    checkJobCompleted(val) {
      if (val) {
        let status = this.repairStatus.find(o => o.code == "REP");
        this.formModel.status_id = status.id;
      }
    },
    isFormDisabled() {
      let res = true;
      if (this.user) {
        if (this.user.isRole(2) || this.user.isRole(3)) res = true;
        else res = false;
      }
      return res;
    }
  },
  mounted() {
    this.getLibrary();
    let id = this.$route.params.id;
    if (id) this.isLoading = true;
    this.$store.dispatch("uld/fetchDamageDescriptions", { limit: 9999 });

    this.$store.dispatch("uld/fetch", id).then(data => {
      this.isLoading = false;
      this.formModel = { ...data };
      if (!this.formModel.supervisor_id) {
        if (this.user.user_type == 4) {
          this.formModel.supervisor_id = this.user.id;
        }
      }
      if (!this.formModel.pre_approved_by_id) {
        if (this.user.user_type == 4) {
          this.formModel.pre_approved_by_id = this.user.id;
        }
      }
      Masterlist.searchUld({
        q: "",
        id: this.formModel.masterlist_id,
        limit: 15
      }).then(resp => {
        this.masterlist = resp;
      });
    });
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #333;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #333;
  }
}
</style>
